export { ReactComponent as DoubleBetBtn } from './DoubleBetBtn.svg';
export { ReactComponent as DoubleBetDisableBtn } from './DoubleBetDisableBtn.svg';
export { ReactComponent as PlayerBetIcon } from './PlayerBetIcon.svg';
export { ReactComponent as RebetBtn } from './RebetBtn.svg';
export { ReactComponent as RebetDisableBtn } from './RebetDisableBtn.svg';
export { ReactComponent as UndoBtn } from './UndoBtn.svg';
export { ReactComponent as UndoDisableBtn } from './UndoDisableBtn.svg';